import type { ComponentProps } from 'react';
import { ComponentBox } from '@/admins/SmartReports/components/Components/Common/ComponentBox';
import Graph from '@/components/Graphs/graph';

type GraphProps = ComponentProps<typeof Graph>;

type GraphWrapperProps = {
  data: GraphProps['data'];
  layout: GraphProps['layout'];
} & Partial<Omit<GraphProps, 'data' | 'layout'>>;

const GraphWrapper = ({ config = {}, ...props }: GraphWrapperProps) => {
  return (
    <ComponentBox>
      <Graph
        title={undefined}
        xlabel={undefined}
        ylabel={undefined}
        loading={undefined}
        onUpdate={undefined}
        onClick={undefined}
        onRelayout={undefined}
        onInitialized={undefined}
        onAfterPlot={undefined}
        maxY={undefined}
        darkTheme={undefined}
        context={undefined}
        {...props}
        config={{
          // responsive: false,
          // staticPlot: true,
          ...config,
        }}
      />
    </ComponentBox>
  );
};

export { GraphWrapper };
